import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

function Stars({ rating }) {
  const stars = [];

  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      stars.push(<FaStar key={i} className="text-green-1 text-sm" />);
    } else if (rating >= i - 0.5) {
      stars.push(<FaStarHalfAlt key={i} className="text-green-1 text-sm" />);
    } else {
      stars.push(<FaRegStar key={i} className="text-gray-300 text-sm" />);
    }
  }

  return <div className="flex items-center space-x-1">{stars}</div>;
}

export default Stars;
